<p-dialog
  [(visible)]="visible"
  [header]="dialogTitle"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  [style]="{width: dialogWidth}"
  [baseZIndex]="10000"
  (onHide)="onDialogHide()"
>
  <div class="mt-2 mb-4 text-sm text-red-500">{{ 'global.required.fields.label' | translate }}</div>
  <!-- Feedback Form -->
  <form (ngSubmit)="onSubmitFeedback()" autocomplete="off">
    <div class="field mb-4">
      <label for="category" class="font-medium"
        >{{'open.feedback.category.label' | translate}}<span class="text-red-500">*</span></label
      >
      <p-select
        id="category"
        [(ngModel)]="category"
        [options]="categoryOptions"
        name="category"
        class="w-full bg-[#f7f7f7] rounded-lg border border-[#e0e0e0] mt-2"
        [placeholder]="'open.feedback.category.placeholder.label' | translate"
        required
      >
      </p-select>
    </div>
    <div class="field mb-4">
      <label for="subject" class="font-medium"
        >{{'open.feedback.subject.label' | translate}}<span class="text-red-500">*</span></label
      >
      <input
        id="subject"
        type="text"
        pInputText
        [(ngModel)]="subject"
        name="subject"
        [placeholder]="'open.feedback.subject.placeholder.label' | translate"
        class="w-full bg-[#f7f7f7] rounded-lg border border-[#e0e0e0] mt-2"
        required
      />
    </div>
    <div class="field mb-4">
      <label for="message" class="font-medium"
        >{{'open.feedback.message.label' | translate}}<span class="text-red-500">*</span></label
      >
      <textarea
        pTextarea
        id="message"
        name="message"
        [placeholder]="'open.feedback.message.placeholder.label' | translate"
        rows="5"
        class="w-full bg-[#f7f7f7] rounded-lg border border-[#e0e0e0] mt-2"
        [(ngModel)]="message"
        required
      ></textarea>
    </div>
    <div class="field mb-4">
      <label class="font-medium">{{'open.feedback.attach.file.label' | translate}}</label>
      <div class="mt-2">
        <label
          class="upload-btn flex items-center gap-2 cursor-pointer border border-blue-900 p-2 rounded-lg text-[#00205B] bg-white font-medium border-[1.5px]"
          [class.opacity-50]="attachedFiles.length >= 2"
          [class.pointer-events-none]="attachedFiles.length >= 2"
        >
          <i class="pi pi-upload"></i>
          <input
            type="file"
            accept=".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png,.gif"
            (change)="onFileSelected($event)"
            hidden
            multiple
            [disabled]="attachedFiles.length >= 2"
          />
        </label>
      </div>
      <div *ngIf="attachedFiles.length > 0" class="flex flex-wrap gap-2">
        <div
          *ngFor="let file of attachedFiles; let i = index"
          class="flex w-min items-center justify-between border border-blue-900 py-2 ps-3 pe-1 rounded-lg bg-[#f7f7f7] mb-2"
        >
          <div class="flex flex-col">
            <span>{{ file?.name }}</span>
            <span class="text-xs text-600">{{ file && file.size ? (file.size / 1024 | number:'1.0-0') : 0 }}kb</span>
          </div>
          <button
            type="button"
            pButton
            icon="pi pi-times"
            class="p-button-rounded p-button-text"
            (click)="removeFile(i)"
          ></button>
        </div>
      </div>
    </div>
    <span class="text-red-500">{{'open.feedback.file.extensions.allowed.label' | translate}}</span>
    <button
      pButton
      type="submit"
      class="w-full mt-4 bg-[#1a237e] text-white rounded-[12px] font-semibold text-lg h-12"
      [disabled]="loading || !subject || !category || !message"
    >
      <span *ngIf="!loading">{{'open.feedback.submit.label' | translate}}</span>
      <span *ngIf="loading"><i class="pi pi-spin pi-spinner"></i>{{'open.feedback.sending.label' | translate}}</span>
    </button>
  </form>
</p-dialog>

<p-toast></p-toast>